import {
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useForm, useFormContext } from "react-hook-form";
import WSTextField, { CurrencyType, TextType } from "../../Components/TextBox/WSTextBox";
import WSDateField from "../../Components/DateField/WSDateField";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import WSSelectField from "../../Components/Select/WSSelect";
import { WSIcons } from "../../commonFunctions/iIcons";
 
export const Pricing: React.FC<any> = React.memo((props) => {
  const { control, register } = useForm();


  return (
    <>
      <Grid container spacing={2}>
                <Grid item xs={12} >
                    <Typography fontWeight={"bold"} variant="h6">
                         Sale Price
                        </Typography>
                    </Grid>

         
        <Grid item xs={12} sm={3}>
        <WSTextField
            label={"Sale Price"}
            {...register("salePrice")}
            id="salePrice"
            name="salePrice"
             type={TextType.Currency}
            currency={CurrencyType.Dollar}
            control={control}
            rules={{ required: false }}
          />
        </Grid>
         <Grid item xs={12} sm={3}>
         <WSSelectField
                rules={{ required: true }}
                control={control}
                id="sale"
                {...register("sale")}
                name="sale"
                label=""
                defaultValue={'Without Tax'}
              />
        </Grid>
        <Grid item xs={12} sm={3}>
        <WSTextField
            label={"Disc. on Sale Price"}
            {...register("disconsalePrice")}
            id="disconsalePrice"
            name="disconsalePrice"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
          <Grid item xs={12} sm={3}>
         <WSSelectField
                rules={{ required: true }}
                control={control}
                id="perc"
                {...register("perc")}
                name="perc"
                label=""
                defaultValue={'Percentage'}
              />
        </Grid>
        <Grid item xs={12}>
                      <span style={{color:"blue"}}><WSIcons.AddIcon /> Add wholesale Price  </span> 
            
           
        </Grid>
        <Grid item xs={12}  >
<Typography>Purchase Price</Typography>
        </Grid>
        <Grid item xs={12}  sm={6}>
    <WSTextField
            label={"Purchase Price"}
            {...register("purchasePrice")}
            id="purchasePrice"
            name="purchasePrice"
            type={TextType.Currency}
            currency={CurrencyType.Dollar}
            control={control}
            rules={{ required: false }}
          />
        </Grid>
          <Grid item xs={12}  sm={6}>
     <WSSelectField
                rules={{ required: true }}
                control={control}
                id="purchaseSale"
                {...register("purchaseSale")}
                name="purchaseSale"
                label=""
                defaultValue={'Without Tax'}
              />
        </Grid>
        <Grid item xs={12}>
          <Typography>Taxes</Typography>
        </Grid>
        <Grid item xs={12}>
<WSSelectField
                rules={{ required: true }}
                control={control}
                id="purchaseSale"
                {...register("purchaseSale")}
                name="purchaseSale"
                label=""
                defaultValue={'Without Tax'}
              />
                      </Grid>
      </Grid>
    </>
  );
});
